<template>
	<BaseFundCard
		:fundData="fundData"
		v-slot="{
			nameTruncated,
			fundStats
		}"
	>
		<div class="fund-card" :class="sizeClasses" :title="titleAttribute">
			<FundCardHeader :fundData="fundData" :name="nameTruncated" />

			<FundCardStats :fundStats="fundStats" />
		</div>
	</BaseFundCard>
</template>

<script>
import BaseFundCard from "./base/BaseFundCard";
import { FundCardHeader, FundCardStats } from "./components";

/**
 * These components make use of a base component ([`base/BaseFundCard.vue`](./base/README.md)) which handles global calculations and styles, and the sub-components `components/FundCardHeader.vue` and `components/FundCardStats.vue`. Data is passed between the components via props and scoped slots.
 */
export default {
	name: "FundCard",

	components: {
		BaseFundCard,
		FundCardHeader,
		FundCardStats
	},

	props: {
		/**
		 * An object containing the fund data for the card. Possible object properties are: `{ symbol, name, titleAttribute, stats [{ label, value, caption }] }`. If `titleAttribute` is not provided, the title attribute on the Fund Card will default to the `name` value.
		 */
		fundData: {
			type: Object
		},

		/**
		 * An optional string of classes.
		 */
		sizeClasses: {
			type: String,
			default: ""
		}
	},

	data: function () {
		return {
			activeStats: []
		};
	},

	computed: {
		titleAttribute() {
			return this.fundData.titleAttribute
				? this.fundData.titleAttribute
				: this.fundData.name;
		}
	},

	methods: {
		getActiveStatNum(statIndex) {
			if (this.activeStats[statIndex] === undefined) {
				//If stat num is undefined, set to 0
				this.updateActiveStat(0, statIndex);
			}
			return this.activeStats[statIndex];
		},
		updateActiveStat(statItemIndex, statIndex) {
			this.$set(this.activeStats, statIndex, statItemIndex);
		}
	}
};
</script>
